// extracted by mini-css-extract-plugin
module.exports = {"button":"button--38e8c","icon":"icon--66d00","text":"text--940ae"};